export const mockLoginResponse = {
    "log": {
      "version": "1.2",
      "creator": {
        "name": "Firefox",
        "version": "73.0.1"
      },
      "browser": {
        "name": "Firefox",
        "version": "73.0.1"
      },
      "pages": [
        {
          "startedDateTime": "2020-03-10T18:32:13.706+00:00",
          "id": "page_1",
          "pageTimings": {
            "onContentLoad": -2312,
            "onLoad": -2310
          }
        }
      ],
      "entries": [
        {
          "pageref": "page_1",
          "startedDateTime": "2020-03-10T18:32:13.706+00:00",
          "request": {
            "bodySize": 0,
            "method": "OPTIONS",
            "url": "https://deliverytracker-tst-api.factsandit.mindera.com/v1/stores/666/info?statisticsFrom",
            "httpVersion": "HTTP/1.1",
            "headers": [
              {
                "name": "Host",
                "value": "deliverytracker-tst-api.factsandit.mindera.com"
              },
              {
                "name": "User-Agent",
                "value": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:73.0) Gecko/20100101 Firefox/73.0"
              },
              {
                "name": "Accept",
                "value": "*/*"
              },
              {
                "name": "Accept-Language",
                "value": "en-GB,en;q=0.5"
              },
              {
                "name": "Accept-Encoding",
                "value": "gzip, deflate, br"
              },
              {
                "name": "Access-Control-Request-Method",
                "value": "GET"
              },
              {
                "name": "Access-Control-Request-Headers",
                "value": "x-store-code"
              },
              {
                "name": "Referer",
                "value": "https://deliverytracker-tst-web.factsandit.mindera.com/"
              },
              {
                "name": "Origin",
                "value": "https://deliverytracker-tst-web.factsandit.mindera.com"
              },
              {
                "name": "DNT",
                "value": "1"
              },
              {
                "name": "Connection",
                "value": "keep-alive"
              }
            ],
            "cookies": [],
            "queryString": [
              {
                "name": "statisticsFrom",
                "value": ""
              }
            ],
            "headersSize": 531
          },
          "response": {
            "status": 200,
            "statusText": "",
            "httpVersion": "HTTP/1.1",
            "headers": [
              {
                "name": "Server",
                "value": "nginx/1.16.1"
              },
              {
                "name": "Date",
                "value": "Tue, 10 Mar 2020 18:32:13 GMT"
              },
              {
                "name": "Content-Length",
                "value": "0"
              },
              {
                "name": "Connection",
                "value": "keep-alive"
              },
              {
                "name": "Vary",
                "value": "Origin"
              },
              {
                "name": "Vary",
                "value": "Access-Control-Request-Method"
              },
              {
                "name": "Vary",
                "value": "Access-Control-Request-Headers"
              },
              {
                "name": "Access-Control-Allow-Origin",
                "value": "https://deliverytracker-tst-web.factsandit.mindera.com"
              },
              {
                "name": "Access-Control-Allow-Methods",
                "value": "GET"
              },
              {
                "name": "Access-Control-Allow-Headers",
                "value": "x-store-code"
              },
              {
                "name": "Access-Control-Allow-Credentials",
                "value": "true"
              },
              {
                "name": "X-Content-Type-Options",
                "value": "nosniff"
              },
              {
                "name": "X-XSS-Protection",
                "value": "1; mode=block"
              },
              {
                "name": "Cache-Control",
                "value": "no-cache, no-store, max-age=0, must-revalidate"
              },
              {
                "name": "Pragma",
                "value": "no-cache"
              },
              {
                "name": "Expires",
                "value": "0"
              },
              {
                "name": "Front-End-Https",
                "value": "on"
              }
            ],
            "cookies": [],
            "content": {
              "mimeType": "text/plain",
              "size": 0,
              "text": ""
            },
            "redirectURL": "",
            "headersSize": 580,
            "bodySize": 580
          },
          "cache": {},
          "timings": {
            "blocked": 0,
            "dns": 0,
            "connect": 0,
            "ssl": 0,
            "send": 0,
            "wait": 41,
            "receive": 0
          },
          "time": 41,
          "_securityState": "secure",
          "serverIPAddress": "62.28.80.131",
          "connection": "443"
        },
        {
          "pageref": "page_1",
          "startedDateTime": "2020-03-10T18:32:13.783+00:00",
          "request": {
            "bodySize": 0,
            "method": "GET",
            "url": "https://deliverytracker-tst-api.factsandit.mindera.com/v1/stores/666/info?statisticsFrom",
            "httpVersion": "HTTP/1.1",
            "headers": [
              {
                "name": "Host",
                "value": "deliverytracker-tst-api.factsandit.mindera.com"
              },
              {
                "name": "User-Agent",
                "value": "Mozilla/5.0 (Macintosh; Intel Mac OS X 10.15; rv:73.0) Gecko/20100101 Firefox/73.0"
              },
              {
                "name": "Accept",
                "value": "application/json"
              },
              {
                "name": "Accept-Language",
                "value": "en-GB,en;q=0.5"
              },
              {
                "name": "Accept-Encoding",
                "value": "gzip, deflate, br"
              },
              {
                "name": "Referer",
                "value": "https://deliverytracker-tst-web.factsandit.mindera.com/"
              },
              {
                "name": "X-STORE-CODE",
                "value": "666"
              },
              {
                "name": "Origin",
                "value": "https://deliverytracker-tst-web.factsandit.mindera.com"
              },
              {
                "name": "DNT",
                "value": "1"
              },
              {
                "name": "Connection",
                "value": "keep-alive"
              },
              {
                "name": "Cookie",
                "value": "JSESSIONID=3C2553105E5578163DAF07D7F87A64B4"
              }
            ],
            "cookies": [
              {
                "name": "JSESSIONID",
                "value": "3C2553105E5578163DAF07D7F87A64B4"
              }
            ],
            "queryString": [
              {
                "name": "statisticsFrom",
                "value": ""
              }
            ],
            "headersSize": 530
          },
          "response": {
            "status": 200,
            "statusText": "",
            "httpVersion": "HTTP/1.1",
            "headers": [
              {
                "name": "Server",
                "value": "nginx/1.16.1"
              },
              {
                "name": "Date",
                "value": "Tue, 10 Mar 2020 18:32:13 GMT"
              },
              {
                "name": "Content-Type",
                "value": "application/json;charset=UTF-8"
              },
              {
                "name": "Transfer-Encoding",
                "value": "chunked"
              },
              {
                "name": "Connection",
                "value": "keep-alive"
              },
              {
                "name": "Vary",
                "value": "Origin"
              },
              {
                "name": "Vary",
                "value": "Access-Control-Request-Method"
              },
              {
                "name": "Vary",
                "value": "Access-Control-Request-Headers"
              },
              {
                "name": "Access-Control-Allow-Origin",
                "value": "https://deliverytracker-tst-web.factsandit.mindera.com"
              },
              {
                "name": "Access-Control-Allow-Credentials",
                "value": "true"
              },
              {
                "name": "X-Content-Type-Options",
                "value": "nosniff"
              },
              {
                "name": "X-XSS-Protection",
                "value": "1; mode=block"
              },
              {
                "name": "Cache-Control",
                "value": "no-cache, no-store, max-age=0, must-revalidate"
              },
              {
                "name": "Pragma",
                "value": "no-cache"
              },
              {
                "name": "Expires",
                "value": "0"
              },
              {
                "name": "Front-End-Https",
                "value": "on"
              }
            ],
            "cookies": [],
            "content": {
              "mimeType": "application/json; charset=UTF-8",
              "size": 343,
              "text": "{\"code\":\"666\",\"name\":\"PH DEMON\",\"lat\":40.617551,\"lng\":-8.667989,\"expectedDeliveryTime\":30,\"avgDeliveryTime\":0,\"avgStoreTime\":0,\"avgDrivingTime\":0,\"avgPreparationTime\":0,\"avgDispatchTime\":0,\"avgRating\":0.0,\"orders\":[],\"alarms\":[],\"scheduled\":[],\"extra\":{\"scheduled\":1,\"alarms\":0,\"orders\":0,\"drivers\":0,\"validate\":0,\"statistics\":0},\"drivers\":[]}"
            },
            "redirectURL": "",
            "headersSize": 556,
            "bodySize": 899
          },
          "cache": {},
          "timings": {
            "blocked": 0,
            "dns": 0,
            "connect": 0,
            "ssl": 0,
            "send": 0,
            "wait": 38,
            "receive": 0
          },
          "time": 38,
          "_securityState": "secure",
          "serverIPAddress": "62.28.80.131",
          "connection": "443"
        }
      ]
    }
  };
